import { useState, useContext } from "react";

import useApi from "../hooks/useApi";
import productsApi from "../api/products";
import ProductsContext from "../context/productsContext";

const useProducts = () => {
    const { products, setProducts } = useContext(ProductsContext);
    const [loading, setLoading] = useState(true);
    const getProductsApi = useApi(productsApi.getProducts);
    const setProductStatusApi = useApi(productsApi.setStatus);

    const getProducts = async () => {
        setLoading(true);
        console.log("Loading products started");

        const response = await getProductsApi.request();
        if (!response.ok) {
            console.log("Error loading products");
            setLoading(false);
            return;
        }

        console.log("Made it here");

        setProducts(response.data);

        console.log("Made it here 2");

        setLoading(false);
        console.log("Loading products finished");
    };

    //Update DB
    //If response okay then update local memory to save on API calls
    //get index of product to update
    //if an index is found update
    const setProductStatus = async (productID, status) => {
        const response = await setProductStatusApi.request(productID, status);
        if (response.ok) {
            let productToUpdate = products.findIndex((x) => x._id == productID);

            if (productToUpdate >= 0) {
                console.log("updating local memory (Products)");
                var updatedProducts = [].concat(products);
                updatedProducts[productToUpdate].status = status;

                setProducts(updatedProducts);
            }
        }
    };

    return {
        products,
        setProducts,
        getProducts,
        setProductStatus,
        loading,
    };
};

export default useProducts;
